var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParameterBasedEstimateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 15H6.89583V13H8.97917V11.5H6.89583V9.5H5.33333V11.5H3.25V13H5.33333V15ZM10.5417 14.25H15.75V12.75H10.5417V14.25ZM10.5417 11.75H15.75V10.25H10.5417V11.75ZM11.6875 7.95L13.1458 6.55L14.6042 7.95L15.6979 6.9L14.2396 5.45L15.6979 4.05L14.6042 3L13.1458 4.4L11.6875 3L10.5938 4.05L12.0521 5.45L10.5938 6.9L11.6875 7.95ZM3.51042 6.2H8.71875V4.7H3.51042V6.2ZM2.20833 18C1.63542 18 1.14497 17.8042 0.736979 17.4125C0.328993 17.0208 0.125 16.55 0.125 16V2C0.125 1.45 0.328993 0.979167 0.736979 0.5875C1.14497 0.195833 1.63542 0 2.20833 0H16.7917C17.3646 0 17.855 0.195833 18.263 0.5875C18.671 0.979167 18.875 1.45 18.875 2V16C18.875 16.55 18.671 17.0208 18.263 17.4125C17.855 17.8042 17.3646 18 16.7917 18H2.20833ZM2.20833 16H16.7917V2H2.20833V16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameterBasedEstimateIcon);
export default __webpack_public_path__ + "static/media/ParameterBasedEstimateIcon.319acb59e42d8339db031957380f3e9e.svg";
export { ForwardRef as ReactComponent };